import { AccountTransactionsImporterTemplateDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useGetImportTemplate = (currency: string) => {
  const [getAccountTransactionsTemplate, { loading }] = useMutation(
    AccountTransactionsImporterTemplateDocument,
    {
      extractorFn: (data) => data.bankingMutations.getBankingTransactionImportTemplate,
    }
  )

  return {
    loading,
    getAccountTransactionsTemplate() {
      return getAccountTransactionsTemplate({
        variables: {
          currency,
        },
      })
    },
  }
}
